import { normalizeCompanyName } from './normalise.js';
/**
 * Return only an opportunity that is genuinely relevant to this contact's company.
 * Never fall back to an unrelated global opportunity: that can corrupt script/case-study
 * recommendations for the person being prepared.
 */
export function findRelevantOpportunityForContact(contact, opportunities) {
    const active = opportunities.filter(o => ['contact-now', 'opening-soon'].includes(o.status));
    const byId = active.find(o => o.companyId && o.companyId === contact.companyId);
    if (byId)
        return byId;
    const company = normalizeCompanyName(contact.companyName);
    if (!company)
        return undefined;
    const direct = active.find(o => o.companyName && normalizeCompanyName(o.companyName) === company);
    if (direct)
        return direct;
    // Radar opportunities often store sponsors / organisers / agencies as target companies
    // rather than as the opportunity's primary company. Preserve that context when the
    // user later reopens the contact from Queue, Contacts or Email Center.
    return active.find(o => (o.targetCompanies || []).some(target => normalizeCompanyName(target.name) === company));
}
